export default "__VITE_ASSET__DgtCJ1LD__"